import { Fragment, useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useMutation, useQuery } from "react-query";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import logo from "../Components/Common/svg/dayemLogo.png";
import LoadingSpinner from "../Components/UI/spinner/index";
import { csrf, loginAuth } from "../MyApi/admin/auth";
import AuthContext from "../_helper/auth";
import {  getCountriesUser } from "../MyApi/admin/countries/countries";
import { use } from "react";
import permissionContext from "../_helper/permissions";
import axios from "axios";
import ShowPasswordIcon from "../Components/Common/svg/showpassword";
import HiddenPasswordIcon from "../Components/Common/svg/hiddenpassword";
import { requestPermisson } from "../firebase";

const Login = ({ setAuthenticated }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const [country_id, setCountryId] = useState("");

  const history = useNavigate();
  const { t, i18n } = useTranslation();
  const { authenticated } = useContext(AuthContext);
  const {setPermissions}=useContext(permissionContext)
  const [csrfToken,setCsrfToken] =useState("")

  const isAuthenticated = JSON.parse(localStorage.getItem("authenticated"));
  const { data, isLoading } = useQuery("getCountries", getCountriesUser);
  const countries = data?.data?.countries || [];


// useEffect(()=>{
//   const getCrsfToken = async()=>{

//     const res= await csrf()
//     console.log('res', res.headers["set-cookie"])
//     return res
//   }
//    getCrsfToken()
   
// },[])

  const mutation = useMutation({
    mutationKey: ["postlogin"],
    mutationFn: (postData) => loginAuth(postData),
    onSuccess: (data) => {
      if (data.success) {
 
        const token = data.data.token;
        const user = data.data.admin;
        const permissions=data.data.permissions ;
        const role =data.data.role ;
       setPermissions(permissions)  
        localStorage.setItem("token" , token);
        localStorage.setItem("permissions",  JSON.stringify(permissions) )
        localStorage.setItem("role" ,JSON.stringify(role))
        setAuthenticated(true);
        localStorage.setItem("i18nextLng", i18n.language);
        localStorage.setItem("user", JSON.stringify(user));
        if(token){
        history(`${process.env.PUBLIC_URL}/home`);
        toast.success(`${data.message}`);
        }
       
       
      }
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  const submitLogin = async () => {
   
 
    mutation.mutate({
      email,
      password,
      country_id
    });
  };
  const handleChange=(e)=>{
setCountryId(e.target.value)
  }

  if (loading) {
    return <LoadingSpinner />;
  }
  if (authenticated) {
    return <Navigate to={`${process.env.PUBLIC_URL}/home`} />;
  }
  return (
    <Fragment>
      <div
        className="p-0 container-fluid"
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
      >
        <header className="login-header">
          <img src={logo} alt="logo" style={{width:"200px"}} />
        </header>
        <Row>
          <Col className="col-12">
            <div className=" login-main">
              <div className="login-card ">
                <h1 className="login-title">تسجيل الدخول</h1>
                <p className="login-desc">سجّل دخولك للوصول إلى حسابك</p>
                <div className="theme-form">
                  <FormGroup>  
                    <Label className="col-form-label" data-test-id="login-email-label">
                      {t("Email Address")}
                    </Label>
                    <Input
                      className="form-control"
                      type="email"
                      required=""
                      onChange={(e) => setEmail(e.target.value)}
                      defaultValue={email}
                      data-test-id="login-username"
                    />
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label" data-test-id="login-password-label">{t("Password")}</Label>
                    <Input
                      className="form-control"
                      type={togglePassword ? "text" : "password"}
                      onChange={(e) => setPassword(e.target.value)}
                      defaultValue={password}
                      required=""
                      data-test-id="login-password"
                    />     
           
                 <button  className="position-absolute input-btn "  style={{top:"50px"}}    onClick={() => setTogglePassword(!togglePassword)}> {togglePassword ?   <HiddenPasswordIcon />   : <ShowPasswordIcon />  }</button>  
                    
                  </FormGroup>
                  {/* <label htmlFor="">الدولة</label>
                  <select className="form-select" onChange={handleChange}>
                    <option value="">
                       اختر الدولة
                    </option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select> */}

                  <div className="form-group mb-2" >
                    <div className="checkbox ms-3">
                      {/* <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" for="checkbox1">
                        {t("RememberPassword")}
                      </Label> */}
                    </div>

                    <button
                      type="button"
                      className={`btn-block btn-primary position-relative btn w-100  ${
                        mutation.isLoading ? "loader" : ""
                      }`}
                      disabled={mutation.isLoading}
                      onClick={() => submitLogin()}
                      data-test-id="login-submit"
                    >
                      <span>{t("Login")} </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default Login;
